import React, { useEffect } from "react";
import BusUtilizationChart from "./Busutilization";
import Busoccupancy from "./Busoccupancy";
import RoutewiseBusOccupancy from "./RoutewiseBusOccupancy";
import BusArrivalCount from "./BusArrivalCount";
import BusTravel from "./BusTravel";
const Analytics = () => {
  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-12 col-sm-6 mt-1">
           <BusArrivalCount />
          
        </div>
        <div className="col-12 col-sm-6 mt-1">
          <BusTravel/>
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-sm-6 mt-1">
         <RoutewiseBusOccupancy />
        </div>
        <div className="col-12 col-sm-6 mt-1">
          <BusUtilizationChart />
        </div>
      </div>
    </div>
  );
};

export default Analytics;
